import Vue from "vue";
import axios from "axios";
import dotenv from "dotenv";
import { stripeTestKey, stripeProdKey } from "../const";
import { store } from "@/store";
import { NotificationStore } from "@/components/NotificationPlugin";
import { i18n, router } from "@/main";

export const EventBus = new Vue();

dotenv.config();

export var ROOT_URL = window.location.origin;
export var RPA_IMAGE_URL = "https://dashboard.rpaswilco.com/img/rpa.png";
export var STRIPE_KEY = stripeProdKey;
export var BLOB_URL = "https://rpaswilco.com";
export var LANDING_BASE_URL = "https://rpaswilco.com";
export var DASHBOARD_BASE_URL = "https://dashboard.rpaswilco.com";

if (process.env.NODE_ENV === "development") {
  ROOT_URL = "http://localhost:5000";
  BLOB_URL = "https://test.rpaswilco.com";
  RPA_IMAGE_URL = "https://testdashboard.rpaswilco.com/img/rpa.png";
  STRIPE_KEY = stripeTestKey;
  LANDING_BASE_URL = "http://localhost:8080/#";
  DASHBOARD_BASE_URL = "http://localhost:8080";
}

if (
  window.location.hostname === "test.rpaswilco.com" ||
  window.location.hostname === "testdashboard.rpaswilco.com"
) {
  BLOB_URL = "https://test.rpaswilco.com";
  RPA_IMAGE_URL = "https://testdashboard.rpaswilco.com/img/rpa.png";
  STRIPE_KEY = stripeTestKey;
  LANDING_BASE_URL = "https://testdashboard.rpaswilco.com/#";
  DASHBOARD_BASE_URL = "https://testdashboard.rpaswilco.com";
}

export var API_URL =
  (process.env.NODE_ENV === "development" ? ROOT_URL : BLOB_URL) + "/api";
export var CFS_URL = BLOB_URL + "/cfs_pdf/";
export var MAP_PDF_URL = BLOB_URL + "/site_pdf/";
export var MAP_IMG_URL = BLOB_URL + "/mapimages/";
export var MAP_SMS_URL = BLOB_URL + "/sms/";
export var LICENSE_URL = BLOB_URL + "/docs/licenses/";
export var CERTIFICATE_URL = BLOB_URL + "/docs/certificates/";
export var NOTICE_URL = BLOB_URL + "/docs/notices/";
export var FLIGHT_REVIEW_RUBRIC_URL = BLOB_URL + "/docs/flightReviewRubric/";
export var FLIGHT_REVIEW_URL = BLOB_URL + "/docs/flight_review";

axios.defaults.withCredentials = true;

export var createGeoJSONCircle = function(coords, radiusInM) {
  var m = radiusInM;

  var ret = [];
  var distanceX = m / (111320.0 * Math.cos((coords.lat * Math.PI) / 180));
  var distanceY = m / 110574.0;

  var theta, x, y;
  for (var i = 0; i < 64; i++) {
    theta = (i / 64) * (2 * Math.PI);
    x = distanceX * Math.cos(theta);
    y = distanceY * Math.sin(theta);

    ret.push([coords.lng + x, coords.lat + y]);
  }
  ret.push(ret[0]);

  return {
    type: "FeatureCollection",
    features: [
      {
        type: "Feature",
        geometry: {
          type: "Polygon",
          coordinates: [ret]
        }
      }
    ]
  };
};

export function getRandomColor() {
  // enerate random RGB values between 0 and 255
  const r = Math.floor(Math.random() * 256);
  const g = Math.floor(Math.random() * 256);
  const b = Math.floor(Math.random() * 256);

  // calc brightness
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;

  // if too dark, recreate
  if (brightness < 128) {
    return getRandomColor();
  }

  return `rgb(${r}, ${g}, ${b})`;
}

const fetch = axios.create({
  baseURL: API_URL
});

// fetch.interceptors.request.use(config => {
//   return config;
// });

fetch.interceptors.response.use(
  res => {
    if (res.status !== 200) return Promise.reject(res);
    else if (res.data && res.data.code && res.data.code !== 200) {
      if (!res.config.useCustomExceptionReminder) {
        NotificationStore.notify({
          message: i18n.t("Server busy, please try again later."),
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "warning",
          timeout: 3000
        });
      }

      return Promise.reject(res);
    }
    return res;
  },

  ({ response: { status, data } }) => {
    const NO_REFRESH_URL_PATH = [
      "/flight-review/map",
      "/processing"
    ];
    if (status === 401 && NO_REFRESH_URL_PATH.indexOf(router.history.current.path) === -1) {
      store.dispatch("auth/refreshToken");
      return (location.href = `/`);
    }

    return Promise.reject(data);
  }
);

export { fetch };
